import { useQuery, UseQueryOptions } from 'react-query';

import { MilestoneReport, Guid } from '../../models';
import { useApi } from '../../context';
import { AxiosUtils } from '../../utils';
import { CerebroApiEndpoints } from '../../utils/api';
import { QueryKeys } from '.';

export function useDataRoomMilestoneQuery(
	guid: Guid | undefined,
	options?:
		| Omit<UseQueryOptions<MilestoneReport[], unknown, MilestoneReport[], any>, 'queryKey' | 'queryFn'>
		| undefined
) {
	const api = useApi();

	return useQuery(
		QueryKeys.Milestones.Root(guid),
		() => AxiosUtils.getResponseData<MilestoneReport[]>(api.get(CerebroApiEndpoints.Milestones.Root(guid))),
		options
	);
}
